// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-password-modal-modal_card-OL7ne {
  width: 340px;
  height: auto;
  max-height: 600px;
}

.update-password-modal-textField_container-hvNFb {
  width: 100%;
  margin-top: 24px;
}

.update-password-modal-item-GPTwI {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.update-password-modal-itemTitle-uMMFH {
  font-size: 14px;
  color: var(--color-neutral-800);
}
  
.update-password-modal-itemValue-WJhiX {
  font-size: 16px;
  font-weight: 500;
  color: var(--color-neutral-800);
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/users/update-password-modal/update-password-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  max-height: 600px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.itemTitle {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n  \n.itemValue {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--color-neutral-800);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `update-password-modal-modal_card-OL7ne`,
	"textField_container": `update-password-modal-textField_container-hvNFb`,
	"item": `update-password-modal-item-GPTwI`,
	"itemTitle": `update-password-modal-itemTitle-uMMFH`,
	"itemValue": `update-password-modal-itemValue-WJhiX`
};
export default ___CSS_LOADER_EXPORT___;
